import { gql } from '@apollo/client';
import {
  AnyFieldValueFragment,
  BasicFieldValueFragment,
} from '../../../utils/apollo/fields';

export default gql`
  query GetFieldValues(
    $term: String
    $schemaId: ID!
    $fieldKey: ID!
    $includeValues: [String!]!
    $parents: [String!]!
    $events: [EventInput!]!
    $includeAny: Boolean = false
  ) {
    fieldValues(
      schemaId: $schemaId
      fieldKey: $fieldKey
      includeValues: $includeValues
      parents: $parents
      term: $term
      events: $events
      includeAny: $includeAny
    ) {
      ... on BasicFieldValue {
        ...BasicFieldValueFields
      }
      ... on AnyFieldValue {
        ...AnyFieldValueFields
      }
    }
  }
  ${BasicFieldValueFragment}
  ${AnyFieldValueFragment}
`;
